<div class="slider-filter-backdrop" [ngClass]="{'slider-filter-backdrop-open': isOpen}"></div>
<div [ngClass]="{'overlay': isOpen}" (click)="closeDocuments()"></div>
<div class="slider-filter-content" [ngClass]="{'slider-open': isOpen}">
    <div #stickyFilterHeader class="slider-filter-header">
        <div class="label">
            Documents
            <span class="document-count-badge"
            [style.border-color]="allDocumentsVerified === true ? 'green' : 'red'"
            [style.color]="allDocumentsVerified === true ? 'green' : 'red'"
            [title]="allDocumentsVerified === true ? 'All documents verified' : (count || 0) + ' document(s) require action'"
            >{{count || 0}}</span>
            <span class="badge-info-text"
                  [class.badge-info-text--verified]="allDocumentsVerified === true"
                  [class.badge-info-text--action]="allDocumentsVerified !== true">
                {{ allDocumentsVerified === true ? 'All verified' : 'Actions required' }}
            </span>
        </div>
        <button type="button" class="jc-v3-cps-hdr-close" (click)="closeDocuments()" aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
        </button>
    </div>
    <div class="slider-filter-body">
        <!-- Header for Candidate/Submitter View -->
        <div *ngIf="pageName === 'job-card'" style="border-bottom: 1px solid #ccc; background-color: #f0f9ff; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
                <ng-icon name="tablerUpload" style="color: #3b82f6; font-size: 20px;"></ng-icon>
                <h5 style="margin: 0; color: #1e40af;">Submitting Documents</h5>
            </div>
            <p style="margin-bottom: 2px; color: #374151;">Upload all below listed documents for verification</p>
            <p style="margin: 0; color: #6b7280; font-size: 13px;">
                <ng-icon name="tablerLock" style="font-size: 15px; margin-top: -7px;"></ng-icon> End-to-end encrypted. Only you and the document requestor can view these files.
            </p>
        </div>

        <!-- Header for Recruiter/Requester View -->
        <div *ngIf="pageName === 'candidate-card'" style="border-bottom: 1px solid #ccc; background-color: #fef3c7; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
                <ng-icon name="tablerClipboardCheck" style="color: #d97706; font-size: 20px;"></ng-icon>
                <h5 style="margin: 0; color: #92400e;">Requesting & Verifying Documents</h5>
            </div>
            <p style="margin-bottom: 2px; color: #374151;">Review and verify candidate submitted documents</p>
            <p style="margin: 0; color: #6b7280; font-size: 13px;">
                <ng-icon name="tablerShield" style="font-size: 15px;margin-top: -6px;"></ng-icon> All documents are encrypted and secure. Mark documents as verified or rejected.
            </p>
        </div>
        <div *ngFor="let d of listOfDocuments; let i = index" class="accordion-item">
            <!-- Header Row -->             
            <div class="document-header" (click)="toggleAccordion(i)">
                <div class="document-name" >
                    <ng-icon name="tablerFileDescription" class="document-icon mr-1"></ng-icon>
                    {{ d.name }}
                    <ng-icon name="tablerLock" class="document-icon mr-1"></ng-icon>
                    <span class="mandatory-badge" *ngIf="d.mandatory">
                        <ng-icon name="tablerAlertCircle"></ng-icon> Mandatory
                    </span>
                    <span class="optional-badge" *ngIf="!d.mandatory">
                        <ng-icon name="tablerInfoCircle"></ng-icon> Optional
                    </span>
                    <span *ngIf="d.documents && d.documents.length > 0"
                          [ngClass]="getDocumentHeaderStatus(d.documents)"
                          class="document-header-status">
                        {{ getDocumentHeaderStatusText(d.documents) }}
                    </span>
                </div>

                <div class="document-header-actions">
                    <label class="switch" *ngIf="pageName ==='candidate-card'">
                        <span class="switch-text">Document</span>
                        <input type="checkbox" [(ngModel)]="d.mandatory" />
                        <span class="slider"></span>
                    </label>
                    <button *ngIf="pageName ==='job-card'" class="btn btn-primary me-3 doc-upload-btn"
                     (click)="openModal(Upload, d.name,'create')"
                     [disabled]="isPendingAvailable(d.documents)">
                        <ng-icon name="tablerUpload" class="mr-1 doc-upload-btn-ico"></ng-icon>
                        Upload
                    </button>
                    <!-- <button class="btn btn-primary me-3"
                     *ngIf="pageName ==='candidate-card' && d.documents.length == 0"
                     (click)="openModal(Upload, d.name,'create')">
                        <ng-icon name="tablerUpload" class="mr-1"></ng-icon>
                        Upload
                    </button> -->
                    <ng-icon class="accordion-chevron"
                       [name]="expandedIndex === i ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
                </div>
            </div>

            <!-- Expanded Content -->
            <div class="accordion-body" *ngIf="expandedIndex === i">
                <div class="upload-section" *ngIf="d.documents?.length > 0; else nodatafound">
                    <div class="table-container">
                        <table class="table w-100">
                            <thead style="background: aliceblue;">
                                <tr>
                                    <th class="t-head" *ngFor="let header of getTableHeaders(d.name)">{{ header }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let doc of d.documents">
                                    <ng-container *ngFor="let header of getTableHeaders(d.name)">
                                        <!-- Document Name Column -->
                                        <td class="fw-bold" *ngIf="header === 'Document Name'"
                                            (click)="downloadDocument(doc)"
                                            [title]="doc?.originalFileName"
                                            style="text-decoration: underline; color: darkcyan; cursor: pointer;">
                                            {{ doc?.originalFileName?.split('.').slice(0, -1).join('.') | truncate : 22}}
                                        </td>

                                        <!-- Document Type Column -->
                                        <td class="fw-bold" *ngIf="header === 'Document Type'">
                                            {{ getFieldValue(doc, 'employDocumentType') }}
                                        </td>

                                        <!-- Issue Date / Valid From Column -->
                                        <td class="fw-bold" *ngIf="header === 'Issue Date' || header === 'Arrival Date'">
                                            {{ getFieldValue(doc, 'validFromDate') }}
                                        </td>

                                        <td class="fw-bold" *ngIf="header === 'Valid From'">
                                            {{ getFieldValue(doc, 'validFromDate') }}
                                        </td>

                                        <!-- Expiry / Expiration Date Column -->
                                        <td class="fw-bold" *ngIf="header === 'Expiration Date'">
                                            {{ getFieldValue(doc, 'expiryDate') }}
                                        </td>

                                        <td class="fw-bold" *ngIf="header === 'Expiry'">
                                            {{ getFieldValue(doc, 'expiryDate') }}
                                        </td>

                                        <!-- State Column -->
                                        <td class="fw-bold" *ngIf="header === 'State'">
                                            {{ getFieldValue(doc, 'stateOfIssuance') | titlecase }}
                                        </td>

                                        <!-- Country Column -->
                                        <td class="fw-bold" *ngIf="header === 'Country Of Issuance'">
                                            {{ getFieldValue(doc, 'countryOfIssuance') }}
                                        </td>

                                        <td class="fw-bold" *ngIf="header === 'Country Of Citizenship'">
                                            {{ getFieldValue(doc, 'countryOfCitizenship') }}
                                        </td>

                                        <!-- Type Column (Background/Drug Screen) -->
                                        <td class="fw-bold" *ngIf="header === 'Background Type'">
                                            {{ getFieldValue(doc, 'backgroudVerifyType')}}
                                        </td>

                                        <td class="fw-bold" *ngIf="header === 'Drug Screen Type'">
                                            {{ getFieldValue(doc, 'drugScreenType')}}
                                        </td>

                                        <!-- Completed On Column -->
                                        <td class="fw-bold" *ngIf="header === 'Completed On'">
                                            {{ getFieldValue(doc, 'completedOn') }}
                                        </td>

                                        <!-- Result Column -->
                                        <td class="fw-bold" *ngIf="header === 'Result'">
                                            {{ getFieldValue(doc, 'result') | titlecase }}
                                        </td>

                                        <!-- Process Status Column -->
                                        <td class="fw-bold" *ngIf="header === 'Process Status'">
                                            {{ getFieldValue(doc, 'backgroundDrugStatus') }}
                                        </td>

                                        <!-- Last Updated Column -->
                                        <td class="fw-bold" *ngIf="header === 'Last Updated'">
                                            {{ doc?.uploadedOn | date: "MM/dd/yyyy" }}
                                        </td>

                                        <!-- Status Column -->
                                        <td class="fw-bold" *ngIf="header === 'Status'">
                                            <span [ngClass]="getStatusClass(doc?.status)">
                                                {{ getStatusText(doc?.status) }}
                                            </span>
                                        </td>

                                        <!-- Actions Column -->
                                        <td class="icon-actions" style="min-width: 150px;"
                                           *ngIf="header === 'Quick Actions'">
                                            <span *ngIf="pageName ==='candidate-card'  && d.name !== 'Drug Screening' && d.name !== 'Background Verification'"
                                                (click)="openDocument(doc)" title="View Document">
                                                <ng-icon name="tablerEye"></ng-icon>
                                            </span>
                                            <span *ngIf="pageName ==='candidate-card' && !['REJECTED','VERIFIED','EXPIRED'].includes(doc.status)"
                                                (click)="openModal(Upload, d.name,'edit',doc)" title="Verify Document">
                                                <ng-icon name="tablerEdit"></ng-icon>
                                            </span>
                                            <span *ngIf="pageName ==='candidate-card'">
                                                <ng-icon name="tablerShare"></ng-icon>
                                            </span>

                                            <span *ngIf="pageName ==='job-card' && d.name !== 'Drug Screening' && d.name !== 'Background Verification'"
                                                (click)="openDocument(doc)" title="View Document">
                                                <ng-icon name="tablerEye"></ng-icon>
                                            </span>
                                            <span *ngIf="pageName ==='job-card' && doc.status == 'PENDING_VERIFICATION'"
                                                (click)="openModal(Upload, d.name,'edit',doc)" title="Edit Document">
                                                <ng-icon name="tablerEdit"></ng-icon>
                                            </span>
                                            <span *ngIf="pageName ==='job-card' && doc.status != 'VERIFIED'"
                                                (click)="deleteDocument(doc)" title="Delete Document">
                                                <ng-icon name="tablerTrash"></ng-icon>
                                            </span>
                                            <span *ngIf="d.name !== 'Drug Screening' && d.name !== 'Background Verification'"
                                                (click)="downloadDocument(doc)" title="Download Document">
                                                <ng-icon name="tablerDownload"></ng-icon>
                                            </span>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <ng-template #nodatafound>
                    <div class="d-flex bg-gray text-center">
                        No uploaded documents found.
                    </div>
                </ng-template>
            </div>

        </div>
    </div>

    <div class="slider-filter-footer" *ngIf="pageName ==='candidate-card'">
        <div class="slider-filter-footer-items">
            <button class="btn btn-default" (click)="closeDocuments()">Cancel</button>
        </div>
        <div class="slider-filter-footer-items">
            <button class="btn  btn-primary" (click)="saveDocuments()">Save</button>
        </div>
    </div>
</div>

<ng-template #Upload let-modal>
    <div class="header">
        <h4 class="" id="modal-basic-title">{{ pageName === 'job-card' && currentDocumentConfig?.uploadAvailable ? 'Upload ' : '' }} {{DocumentName}}</h4>
        <!-- <button type="button" title="Close" class="btn btn-danger btn-sm" aria-label="Close" (click)="closeModal()" style="margin-right: 0px;">
            x
        </button> -->
        <button type="button" title="Close" aria-label="Close" style="margin-right: 0px;">
            <span (click)="closeModal()" class="common-close">&times;</span>
        </button>
    </div>

    <div class="content">
        <div  *ngIf="(pageName == 'job-card' || (pageName == 'candidate-card' && modalType != 'edit')) && currentDocumentConfig?.uploadAvailable"
             class="dropdox-908" (fileDropped)="onFileDropped($event)" for="fileDropRef" appDnd>
            <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" id="fileDropRef"
                (click)="fileDropRef.value=''"
                (change)="fileBrowseHandler($event.target.files)" />

            <div class="file-icon-908">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="12" y1="18" x2="12" y2="12"></line>
                    <line x1="9" y1="15" x2="15" y2="15"></line>
                </svg>
            </div>
            <div>
                <label class="upload-title-908" for="fileDropRef">Upload Your {{DocumentName}}</label>
            </div>
            <div>
                <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this
                    area.</label>
            </div>
            <div for="fileDropRef">
                <small class="upload-hint-908">Only PDF, DOCX, DOC, PNG, JPG, JPEG, XLSX and XLS file formats supported.</small>
            </div>
            <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                    <polyline points="13 2 13 9 20 9"></polyline>
                </svg>
                <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
                <ng-icon name="tablerX" class="file-remove-908" (click)="removeFiles()"></ng-icon>
            </div>
        </div>

        <div class="text-center" *ngIf="pageName == 'candidate-card' && modalType == 'edit'"
            style="margin-bottom: 20px;">
            <p class="fw-bold mb-2">Please review the document and verify.</p>
            <button class="btn btn-sm btn-outline-primary" (click)="openDocument(documentForm.value)" style="display: inline-flex; align-items: center; gap: 8px;">
                <ng-icon name="tablerEye"></ng-icon>
                View Document
            </button>
        </div>

        <!-- Dynamic Form Fields Section -->
        <div class="form-fields-section" *ngIf="currentDocumentConfig?.fields?.length > 0">
            <form [formGroup]="documentForm">
                <div class="row">
                    <div class="col-md-6" *ngFor="let field of currentDocumentConfig.fields; let i = index">
                        <div class="form-group">
                            <label [for]="field.id" class="form-label">
                                {{field.label}}
                                <span *ngIf="field.required" class="required">*</span>
                            </label>

                            <!-- Text Input -->
                            <input
                                *ngIf="field.type === 'text'"
                                type="text"
                                [id]="field.id"
                                class="form-control"
                                [class.is-invalid]="hasFieldError(field.id)"
                                [placeholder]="field.placeholder || ''"
                                [formControlName]="field.id"
                                [readonly]="field.id === 'originalFileName'"
                                [title]="field.id === 'originalFileName' ? documentForm.get(field.id)?.value || '' : ''"
                                removeWhiteSpace>

                            <!-- Date Input -->
                            <input
                                *ngIf="field.type === 'date'"
                                type="date"
                                [id]="field.id"
                                class="form-control"
                                [class.is-invalid]="hasFieldError(field.id)"
                                [disabled]="isToDateField(field.id) && !getFromDateValue(field.id)"
                                [max]="isFromDateField(field.id) ? getTodayDate() : null"
                                [min]="isToDateField(field.id) ? getFromDateValue(field.id) : null"
                                [formControlName]="field.id">

                            <!-- EAD Document Type - Searchable/Filterable Dropdown -->
                            <ng-select
                                *ngIf="field.type === 'select' && field.id === 'employDocumentType'"
                                [id]="field.id"
                                [items]="field.options || []"
                                [formControlName]="field.id"
                                [placeholder]="isEADDropdownDisabled() ? 'Select Country of Citizenship first' : 'Search or select ' + field.label"
                                [disabled]="isEADDropdownDisabled()"
                                [clearable]="true"
                                [searchable]="true"
                                [addTag]="true"
                                [class.is-invalid]="hasFieldError(field.id)"
                                notFoundText="No document types found"
                                addTagText="Add custom document type"
                                [selectOnTab]="true"
                                [clearSearchOnAdd]="true">
                            </ng-select>

                            <!-- Regular Select Input for other fields -->
                            <!-- <ng-select
                                *ngIf="field.type === 'select' && field.id !== 'employDocumentType' && (field.id === 'countryOfCitizenship' || field.id === 'countryOfIssuance')"
                                [id]="field.id"
                                class="form-control"
                                [class.is-invalid]="hasFieldError(field.id)"
                                [formControlName]="field.id"
                                (change)="field.id === 'countryOfCitizenship' ? onCountryOfCitizenshipChange($event) : null"
                                [items]="field.options"
                                bindLabel="countryName"
                                bindValue="countryCode">
                                <ng-template *ngIf="">
                                    <div *ngFor="let option of field.options" [value]="option.countryCode || option">
                                        {{option.countryName || option}}
                                    </div>
                                </ng-template>
                                <ng-template *ngIf="field.id !== 'countryOfCitizenship' && field.id !== 'countryOfIssuance'">
                                    <div *ngFor="let option of field.options" [value]="option">
                                        {{option}}
                                    </div>
                                </ng-template>
                            </ng-select> -->

                            <!-- country of citizenship -->
                             <!-- <ng-select
                                *ngIf="field.type === 'select' && field.id !== 'employDocumentType' && (field.id === 'countryOfCitizenship' || field.id === 'countryOfIssuance')"
                                [id]="field.id"
                                [class.is-invalid]="hasFieldError(field.id)"
                                [formControlName]="field.id"
                                (change)="field.id === 'countryOfCitizenship' ? onCountryOfCitizenshipChange($event) : null"
                                [items]="field.options"
                                [placeholder]="field.placeholder"
                                bindLabel="countryName"
                                bindValue="countryCode">
                            </ng-select> -->

                            <select *ngIf="field.type === 'select' && field.id !== 'employDocumentType' && (field.id === 'countryOfCitizenship' || field.id === 'countryOfIssuance')"
                                [class.is-invalid]="hasFieldError(field.id)" [id]="field.id" [formControlName]="field.id" type="text" class="form-control input-sm"
                                (change)="field.id === 'countryOfCitizenship' ? onCountryOfCitizenshipChange($event) : null" placeholder="Select Country">
                                <option value="null" selected disabled>Country</option>
                                <option *ngFor="let country of field?.options" [value]="country.countryCode">
                                    {{country.countryName}}</option>
                            </select>

                            <!-- other select values  -->
                             <ng-select
                                *ngIf="field.type === 'select' && field.id !== 'employDocumentType' && (field.id !== 'countryOfCitizenship' && field.id !== 'countryOfIssuance')"
                                [id]="field.id"
                                [class.is-invalid]="hasFieldError(field.id)"
                                [formControlName]="field.id"
                                [placeholder]="field.placeholder"
                                (change)="field.id === 'countryOfCitizenship' ? onCountryOfCitizenshipChange($event) : null"
                                [items]="field.options">
                            </ng-select>

                            <!-- Radio Input -->
                            <div *ngIf="field.type === 'radio'" class="doc-radio-group">
                                <label *ngFor="let option of field.options" class="doc-radio-item"
                                    [for]="field.id + '_' + option">
                                    <input
                                        type="radio"
                                        [id]="field.id + '_' + option"
                                        [value]="option"
                                        [formControlName]="field.id">
                                    <span>{{option}}</span>
                                </label>
                            </div>

                            <!-- Textarea (Full Width) -->
                            <textarea
                                *ngIf="field.type === 'textarea'"
                                [id]="field.id"
                                class="form-control"
                                [class.is-invalid]="hasFieldError(field.id)"
                                [placeholder]="field.placeholder || ''"
                                rows="3"
                                [formControlName]="field.id"
                                removeWhiteSpace>
                            </textarea>

                        </div>
                        <!-- Error Message -->
                        <div class="error-wrapper">
                           <p class="invalid-feedback text-danger" *ngIf="hasFieldError(field.id)" style="margin-bottom: 0;">
                              {{getFieldError(field.id)}}
                            </p>
                        </div>
                    </div>
                </div>
            </form>

            <!-- Rejection Reason Field (Conditional) -->
            <div class="rejection-reason-section" *ngIf="showRejectionReason">
                <form [formGroup]="documentForm">
                    <div class="form-group">
                        <label for="rejectionReason" class="form-label">
                            Reason for Rejection
                            <span class="required">*</span>
                        </label>
                        <textarea
                            id="rejectionReason"
                            class="form-control"
                            [class.is-invalid]="hasFieldError('rejectionReason')"
                            placeholder="Please provide the reason for rejecting this document..."
                            rows="3"
                            formControlName="rejectionReason">
                        </textarea>
                        <div *ngIf="hasFieldError('rejectionReason')" class="invalid-feedback text-danger">
                            {{getFieldError('rejectionReason')}}
                        </div>
                    </div>
                </form>
            </div>
        </div>        
    </div>

    <div *ngIf="pageName ==='job-card'" class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button class="btn btn-primary" (click)="submitModal()">Save</button>
    </div>

    <div *ngIf="pageName ==='candidate-card'" class="modal-footer">
        <div class="status-buttons">
            <button
                type="button"
                class="btn btn-danger btn-sm"
                [class.active]="documentStatus === 'rejected'"
                (click)="rejectDocument('rejected',currentDocumentConfig)">
                Mark as Rejected
            </button>
            <button
                type="button"
                class="btn btn-success btn-sm"
                [class.active]="documentStatus === 'verified'"
                (click)="setDocumentStatus('verified',currentDocumentConfig)">
                Mark as Verified
            </button>
        </div>
    </div>
</ng-template>